module.exports = __webpack_public_path__ + "static/media/icon_Search.0825b07b.svg";